import React from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import HowItWorks from "./components/HowItWorks";
import Adopt from "./components/Adopt";
import GetInvolved from "./components/GetInvolved";
import Footer from "./components/Footer";
import "./App.css";

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <HowItWorks />
      <Adopt />
      <GetInvolved />
      <Footer />
    </div>
  );
}

export default App;
